import {Sortable} from '@shopify/draggable';

import SoundFx from '../../../components/SoundFx';
import Utils from '../../../scripts/utils';

export default function SortableSection() {
  const containerSelector = '.CubesFrame--idSortable';
  const containers = document.querySelectorAll(containerSelector);
  const draggable = new Sortable(containers, {
    mirror: {
      appendTo: containerSelector,
    },
  });

  // --- Drag states --- //
  draggable.on('drag:start', () => {
    SoundFx.Single.play('cubeUp');
  });

  draggable.on(
    'sortable:sorted',
    Utils.debounce(() => {
      SoundFx.Single.play('cubeSort');
    }, 60),
  );

  draggable.on('drag:stop', () => {
    SoundFx.Single.play('cubeDown');
  });

  return draggable;
}
